import { defineStore, } from 'pinia'
import { ref } from 'vue'
import { getRouters } from '../../api/common'
import { filterAsyncRouter } from '../../utils/routes'
import { pinia } from '..'


export const routesStore = defineStore('routes', () => {
    const routes = ref<any[]>([])
    const menuList = ref<any[]>([])
    const getRouter = (): Promise<any[]> => {
        return new Promise((resolve) => {
            getRouters().then(res => {
                const rdata = JSON.parse(JSON.stringify(res.data));
                const lData = JSON.parse(JSON.stringify(res.data));
                const rewriteRoutes = filterAsyncRouter(rdata, false);
                const nav = filterAsyncRouter(lData, true);
                const arr = []
                rewriteRoutes.forEach((route: any) => {
                    if (route.children && route.children.length) {
                        const every = route.children.every(i => i.component)
                        if (every) {
                            arr.push(route)
                        }
                    }
                })
                menuList.value = nav
                rewriteRoutes.push({
                    path: '/',
                    redirect: rewriteRoutes[0].path
                })
                resolve(rewriteRoutes)
            })
        })
    }

    /** 动态挂载路由返回的对应卸载路由函数的集合 */
    const removeRoutes: Function[] = []

    return {
        routes,
        getRouter,
        menuList,
        removeRoutes
    }
})

export const useRouterStore = () => {
    return routesStore(pinia)
} 